// ProfileTenagaKesehatan.jsx
import React from "react";
import "../CSS/ProfileTenagaKesehatan.css";
import { useNavigate } from "react-router-dom";

function ProfileTenagaKesehatan() {
  const navigate = useNavigate();

  const handleEditProfile = () => {
    navigate("/EditDetailProfileTenagaKesehatan");
  };


  return (
    <div className="profile-page">
      <div className="main-contentprofile">
        <div className="content-profile">

          {/* Profile Card */}
          <div className="profile-card">
            <div className="profile-avatar">NK</div>
            <div className="profile-info">
              <h3>Dr. Megumi Fushiguro</h3>
              <p>Dokter Spesialis Paru - RSUD Magetan</p>
              <p className="nip">NIP. 45668989</p>
            </div>
          </div>

          {/* Tabs */}
         

          {/* Informasi Profil */}
          <div className="form-sectionprofile">

            <div className="form-row">
              <div className="form-groupprofile">
                <label>Nama Lengkap</label>
                <input type="text" value="Megumi Fushiguro" readOnly />
              </div>
              <div className="form-groupprofile">
                <label>Email</label>
                <input type="text" value="drfushiguro.megumi@gmail.com" readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. Telepon</label>
                <input type="text" value="085231256566" readOnly />
              </div>
              <div className="form-groupprofile">
                <label>Spesialisasi</label>
                <input type="text" value="Paru-paru" readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. STR</label>
                <input type="text" value="1456789065432" readOnly />
              </div>
              <div className="form-groupprofile">
                <label>Alamat Fasilitas Kesehatan</label>
                <input type="text" value="RSUD Magetan" readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>NIP</label>
                <input type="text" value="45678987657121" readOnly />
              </div>
              <div className="form-groupprofile">
                <label>Profesi</label>
                <input type="text" value="Dokter" readOnly />
              </div>
            </div>

            <div className="btn-edit-container">
              <button className="edit-btn" onClick={handleEditProfile}>
                Edit Profile
              </button>
            </div>
          </div>

          <footer className="footerdebar">
            © 2025 TibiSmart. All rights reserved.
          </footer>

        </div>
      </div>
    </div>
  );
}

export default ProfileTenagaKesehatan;
